import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-item-cardapio',
  templateUrl: './item-cardapio.component.html',
  styleUrls: ['./item-cardapio.component.scss']
})
export class ItemCardapioComponent implements OnInit {

  @Input() type: 'salgadas' | 'salgadas2' | 'doces' | 'bebidas' | 'esfirrao'
  @Input() broto: boolean = false;
  @Input() trem: boolean = false;
  @Input() biTrem: boolean = false;
  /** Preço do tamanho exibido; quando ausente usa os flags broto/trem/biTrem. */
  @Input() preco?: number;
  /** Promoção aplicada ao preço exibido. */
  @Input() promocao?: { precoOriginal: number; destaque: boolean; nome?: string };
  @Input() item: any;
  @Input() user: any;
  @Output('addProduto') addPizza$ = new EventEmitter(null);

  constructor() { }

  ngOnInit() {
  }

  click = 0
  get promocaoRotulo(): string {
    return this.promocao?.nome || (this.promocao?.destaque ? 'Promoção do dia' : 'Promoção');
  }

  addProduto(item) {
    this.addPizza$.emit(item);
  }

  /**
   * Verifica se o item está em estoque
   * Por padrão, considera que está em estoque se o atributo não existir (retrocompatibilidade)
   */
  isEmEstoque(): boolean {
    return this.item?.em_estoque !== false;
  }

}
